import type { ReactElement } from 'react';
import { StyledLabel, StyledInput, StyledText } from './Checkbox.styles';
import { ParagraphType } from '../../atoms/Paragraph/Paragraph.data';

type CheckboxProps = {
  label: string;
  name: string;
  checked: boolean;
  disabled: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChange?: (value: any) => void;
};

export const Checkbox = ({
  label,
  name,
  checked,
  disabled,
  onChange,
  ...props
}: CheckboxProps): ReactElement => {
  return (
    <StyledLabel {...props} $isDisabled={disabled}>
      <StyledInput
        type="checkbox"
        name={name}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
      />
      <StyledText forwardedAs="span" type={ParagraphType.Large}>
        {label}
      </StyledText>
    </StyledLabel>
  );
};
